import Model from 'mewe/utils/store-utils/model/model';
import { attr, belongsTo, hasMany } from 'mewe/utils/store-utils/model/attribute';
import { computed } from '@ember/object';
import { htmlSafe } from '@ember/template';

import { EntryType } from 'mewe/constants';
import SimpleUser from 'mewe/stores/models/simple-user-model';
import Entry from 'mewe/stores/models/entry-model';
import Page from './page-model';

const model = Model.extend({
  id: attr('string'),
  storytellerType: attr('string'),
  userStoryteller: belongsTo(SimpleUser),
  pageStoryteller: belongsTo(Page),
  stories: hasMany(Entry),
  hasNewStories: attr('boolean'),
  userRelation: attr('object', {
    defaultValue: function () {
      return {}; // default to prevent errors in case we try to access it and it's missing
    },
  }), // { canChat, following, public, userId }

  _lastUpdateAt: attr('number'), // local value set when story comes from WS

  get lastUpdatedAt() {
    return this._lastUpdateAt ?? (this.stories.length ? this.stories[this.stories.length - 1]?.createdAt : null);
  },

  get tellerDetails() {
    if (this.storytellerType === 'Page') {
      return this.pageStoryteller;
    } else {
      let user = this.userStoryteller;
      if (this.userRelation) {
        Object.keys(this.userRelation).forEach((key) => {
          user[key] = this.userRelation[key];
        });
      }

      return user;
    }
  },

  tellerAvatar: computed('storytellerType', 'pageStoryteller.avatar', 'userStoryteller._links.avatar.href', function() {
    if (this.storytellerType === 'Page') {
      return this.pageStoryteller?.avatar;
    } else {
      return this.userStoryteller?._links.avatar.href;
    }
  }),

  tellerMediaThumbnail: computed('stories.0.media', function() {
    const entry = this.stories?.[0]?.media;
    if (!entry) return;
    const url = entry.mediaType === EntryType.PHOTO
      ? entry._links?.media?.href.replace('{imageSize}', '400x400')
      : entry._links?.thumbnail?.href.replace('{imageSize}', '400x400');
    return htmlSafe(`background-image: url(${url})`);
  }),

  tellerNameDisplay: computed('storytellerType', 'pageStoryteller.name', 'userStoryteller.firstName', function() {
    if (this.storytellerType === 'Page') {
      return this.pageStoryteller?.name;
    } else {
      return this.userStoryteller?.firstName;
    }
  }),

  isFollowing: computed('userRelation.following', 'pageStoryteller.isFollower', function() {
    if (this.storytellerType === 'Page') {
      return this.pageStoryteller?.isFollower;
    } else {
      return this.userStoryteller.following || this.userRelation?.following;
    }
  }),

  haloClass: computed('hasNewStories', 'isFollowing', function() {
    if (this.hasNewStories) {
      return this.isFollowing ? 'h-halo--unseen' : 'h-halo--unseen-unfollowed';
    }
    return 'h-halo--seen';
  }),

  // set on client side to show the temporary "undo" of follow action
  justFollowed: attr('boolean'),
});

model.reopenClass({
  resourceName: 'teller',
  aliases: {
    storytellerId: 'id',
  },
});

export default model;
